import { render, staticRenderFns } from "./EventTitle.vue?vue&type=template&id=5bdc916c&"
import script from "./EventTitle.vue?vue&type=script&lang=js&"
export * from "./EventTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports